
const digest = '344ca5ef0ed30d165b99b6d4626739fd558e568f765d8cfaf2545f54307e5c3b';
const classes = {"wrapper":"_wrapper_esvrp_1","content":"_content_esvrp_12","title":"_title_esvrp_15","controls":"_controls_esvrp_19"};
const css = `._wrapper_esvrp_1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid #eaedf3;
  padding: 24px 12px;
  gap: 10px;
}
._wrapper_esvrp_1:last-of-type {
  border-bottom: none;
}
._wrapper_esvrp_1 ._content_esvrp_12 {
  flex-grow: 1;
}
._wrapper_esvrp_1 ._content_esvrp_12 ._title_esvrp_15 {
  font-size: 14px;
  font-weight: 500;
}
._wrapper_esvrp_1 ._controls_esvrp_19 {
  display: flex;
  flex-direction: row;
  gap: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  